require('./brokerConsultMiFIDInfoColumn.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

class BrokerConsultMiFIDInfoColumn extends React.Component {

   buildInfoSection() {
        if (this.props.isConsult) {
            return (<div className="broker-consult-mifid-info-column__info">
                <p><FormattedText value="consultMiFID-consultInformation" /></p>
            </div>);
        } else {
            return (<div className="broker-consult-mifid-info-column__info1">
                <p><FormattedText value="consultMiFID-information1" /></p>
                <p><FormattedText value="consultMiFID-information2" /></p>
            </div>);
        }
    }

    render() {
        const info = this.buildInfoSection();

        return (
            <OKSectionBox>
                {info}
                <section key="convenienceMiFID_p3">
                    <div className="broker-consult-mifid-info-column__info-email">
                        <FormattedText value="broker-convenienceMifidTestOnCompletedSendResultsToEmail" />
                    </div>
                </section>
            </OKSectionBox>
        );
    }
}
BrokerConsultMiFIDInfoColumn.propTypes = {
    clientEmail: PropTypes.string,
    isConsult: PropTypes.bool
};

module.exports = BrokerConsultMiFIDInfoColumn;
